// extracted by mini-css-extract-plugin
module.exports = {"text-container":"styles_text-container__qffkp","textContainer":"styles_text-container__qffkp","continue":"styles_continue__2JoKL"};